function UserInfoErrorHandler(response = {}) {
  if (!(response && response.data)) return;
  const { data = {} } = response;
  const { error = {} } = data;
  const { httpCode: statusCode = "no-code", errorCode } = error;
  if (statusCode === 401) {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "sessao-expirada",
          title: "Sessão expirada",
          message: "efetue o login novamente",
        },
      },
    };
  } else if (statusCode === 500) {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "ERRO-500",
          title: "Erro ao consultar seus dados",
          message: "Verifique sua conexão com a internet",
          systemError: data,
        },
      },
    };
  } else {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "ERRO",
          title: "Ocorreu um erro inesperado!",
          message: "Verifique sua conexão com a internet e tente novamente",
          systemError: data,
        },
      },
    };
  }
}
export default UserInfoErrorHandler;
